import { useState } from 'react';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';

const useBillTrackerAlert = () => {
  const [billTrackerAlert, setBillTrackerAlert] = useState(null);
  const { generalApiCall } = useGeneralApiCall();

  const getAlertIdsArray = (string = '') =>
    string
      ?.split(',')
      .map((item) => item.trim())
      .filter(Boolean) ?? [];

  const isBillTracked = (id) => getAlertIdsArray(billTrackerAlert?.settings).includes(`${id}`);

  const getBillTrackerAlert = async ({ source }) => {
    try {
      const result = await generalApiCall({
        method: 'get',
        pathname: '/api/newsletter-subscriptions',
        needsAuthentication: true,
        requestSource: source,
        notShowErrorMessage: true,
      });
      const alert = result?.find((item) => item.type === 'BillTracker') ?? null;
      setBillTrackerAlert(alert);
      return alert;
    } catch (error) {}
  };

  const toggleBillTracker = async ({ id }) => {
    try {
      const ids = getAlertIdsArray(billTrackerAlert?.settings);
      if (!billTrackerAlert) {
        const res = await generalApiCall({
          method: 'post',
          pathname: '/api/newsletter-subscriptions/create',
          requestProperties: { type: 'BillTracker', settings: `${id}` },
          needsAuthentication: true,
        });
        if (res) {
          setBillTrackerAlert(res);
        }
        return;
      }

      const newIds = ids.includes(`${id}`) ? ids.filter((alertId) => alertId !== `${id}`) : [...ids, `${id}`];

      if (newIds.length === 0) {
        await generalApiCall({
          method: 'delete',
          pathname: `/api/newsletter-subscriptions/${billTrackerAlert.id}`,
          needsAuthentication: true,
        });
        setBillTrackerAlert(null);
      } else {
        const settings = newIds.join(',');
        await generalApiCall({
          method: 'post',
          pathname: '/api/newsletter-subscriptions/update',
          requestProperties: { id: billTrackerAlert.id, type: 'BillTracker', settings },
          needsAuthentication: true,
        });
        setBillTrackerAlert({ ...billTrackerAlert, settings });
      }
    } catch (error) {}
  };

  return { isBillTracked, getBillTrackerAlert, toggleBillTracker };
};

export default useBillTrackerAlert;
